module.exports = __webpack_public_path__ + "img/most_visited_pages-w.svg";